import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "*",
      redirect: "/main",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },
    {
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    },
    {
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },
    {
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/print",
      name: RouterNames.mainprintinglayout,
      component: () => import("@/views/printing/MainPrintingLayout.vue"),
      children: [
        {
          path: "inventario",
          name: RouterNames.printinginventario,
          component: () =>
            import("@/views/printing/inventario/PrintingInventario.vue"),
        },
      ],
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () => import("@/views/home/home.vue"),
        },
        {
          path: "qr/:url",
          name: RouterNames.qr,
          component: () => import("@/views/QR/qr_code.vue"),
        },
        {
          path: "tablas",
          name: RouterNames.tablas,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tabla/:id",
              name: RouterNames.table,
              component: () =>
                import("@/views/dynamic_tables/dynamic_table.vue"),
            },
          ],
        },
        {
          path: "empresas",
          name: RouterNames.empresas,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.empresaslista,
              component: () => import("@/views/empresas/EmpresasLista.vue"),
              children: [],
            },
          ],
        },
        {
          path: "inventario",
          name: RouterNames.inventario,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "treeview",
              name: RouterNames.inventario_treeview,
              component: () =>
                import("@/views/inventario/categoria_invetario_view.vue"),
              children: [],
            },
            {
              path: "handler",
              name: RouterNames.handlerinventario_formulario,
              component: () =>
                import("@/views/inventario/handler_ficha_inventario.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.inventario_formulario,
                  component: () =>
                    import("@/views/inventario/ficha_inventario.vue"),
                  children: [],
                },
                {
                  path: "inventario_tareas/:id",
                  name: RouterNames.inventario_tareas,
                  component: () =>
                    import("@/views/inventario/tareas_inventario.vue"),
                  children: [],
                },
                {
                  path: "inventario_incidencias/:id",
                  name: RouterNames.inventario_incidencias,
                  component: () =>
                    import("@/views/inventario/incidencias_inventario.vue"),
                  children: [],
                },
                {
                  path: "subinventarios/:id",
                  name: RouterNames.subinventarios,
                  component: () =>
                    import("@/views/inventario/subinventarios_lista.vue"),
                  children: [],
                },{
                  path: "mediciones/:id",
                  name: RouterNames.mediciones_tecnicas_inventario,
                  component: () =>
                    import("@/views/inventario/mediciones_inventarioView.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "readqr/:id",
              name: RouterNames.readqr_inventario,
              component: () =>
                import("@/views/inventario/readqr_inventario.vue"),
              children: [],
            },
          ],
        },
        {
          path: "incidencias",
          name: RouterNames.todas_incidencias,
          component: () =>
            import("@/views/proyectos/incidencias/incidenciasHandler.vue"),
        },
        {
          path: "tareas",
          name: RouterNames.todas_tareas,
          component: () => import("@/views/proyectos/tareas/tareasHandler.vue"),
        },
        {
          path: "tareas_movil",
          name: RouterNames.todas_tareas_movil,
          component: () =>
            import("@/views/proyectos/tareas/tareas_lista_movil.vue"),
          children: [],
        },
        {
          path: "incidencias_movil",
          name: RouterNames.todas_incidencias_lista_movil,
          component: () =>
            import("@/views/proyectos/incidencias/incidenciasListaMovil.vue"),
          children: [],
        },
        {
          path: "incidencias_movil/:id",
          name: RouterNames.incidencias_movil,
          component: () =>
            import(
              "@/views/proyectos/incidencias/incidenciasFormularioMovil.vue"
            ),
          children: [],
        },
        {
          path: "tareas_formulario_movil/:id",
          name: RouterNames.todas_tareas_movil_formulario,
          component: () =>
            import("@/views/proyectos/tareas/tareasFormularioMovil.vue"),
          children: [],
        },
        {
          path: "administracion",
          name: RouterNames.administracion,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "proyectos",
              name: RouterNames.administracion_proyectos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "prioridades",
                  name: RouterNames.administracion_proyectos_prioridades,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name:
                        RouterNames.administracion_proyectos_prioridadeslista,
                      component: () =>
                        import(
                          "@/views/proyectos/Prioridades/proyectoPrioridades.vue"
                        ),
                      children: [],
                    },
                  ],
                },
                {
                  path: "fases",
                  name: RouterNames.administracion_proyectos_fases,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name: RouterNames.administracion_proyectos_faseslista,
                      component: () =>
                        import("@/views/proyectos/Fases/ProyectoFases.vue"),
                      children: [],
                    },
                  ],
                },
              ],
            },
            {
              path: "incidencias",
              name: RouterNames.administracion_incidencias,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "prioridades",
                  name: RouterNames.administracion_incidencias_prioridades,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name:
                        RouterNames.administracion_incidencias_prioridadeslista,
                      component: () =>
                        import(
                          "@/views/proyectos/incidencias/Prioridades/incidenciasPrioridades.vue"
                        ),
                      children: [],
                    },
                  ],
                },
                {
                  path: "estados",
                  name: RouterNames.administracion_incidencias_estados,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name:
                        RouterNames.administracion_incidencias_estados_lista,
                      component: () =>
                        import(
                          "@/views/proyectos/incidencias/Estados/IncidenciasEstados.vue"
                        ),
                      children: [],
                    },
                  ],
                },
                {
                  path: "categorias",
                  name: RouterNames.administracion_incidencias_categorias,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name:
                        RouterNames.administracion_incidencias_categorias_lista,
                      component: () =>
                        import(
                          "@/views/proyectos/incidencias/Categorias/Incidenciascategorias.vue"
                        ),
                      children: [],
                    },
                  ],
                },
              ],
            },
            {
              path: "tareas",
              name: RouterNames.administracion_tareas,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "estados",
                  name: RouterNames.administracion_tareas_estados,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name: RouterNames.administracion_tareas_estados_lista,
                      component: () =>
                        import(
                          "@/views/proyectos/tareas/Estados/TareasEstados.vue"
                        ),
                      children: [],
                    },
                  ],
                },
                {
                  path: "tipos",
                  name: RouterNames.administracion_tareas_categorias,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name: RouterNames.administracion_tareas_categorias_lista,
                      component: () =>
                        import(
                          "@/views/proyectos/tareas/Tipos/TareasTipos.vue"
                        ),
                      children: [],
                    },
                  ],
                },
                {
                  path: "plantillas",
                  name: RouterNames.administracion_tareas_plantillas,
                  component: () =>
                    import("@/components/titulopantalla/titulo.vue"),
                  children: [
                    {
                      path: "lista",
                      name: RouterNames.administracion_tareas_plantillas_lista,
                      component: () =>
                        import(
                          "@/views/plantillas/tareas/PlantillasTareasLista.vue"
                        ),
                      children: [],
                    },
                    {
                      path: "formulario/:id",
                      name:
                        RouterNames.administracion_tareas_plantillas_formulario,
                      component: () =>
                        import(
                          "@/views/plantillas/tareas/PlantillasTareasFormulario.vue"
                        ),
                      children: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: "proyectos",
          name: RouterNames.proyectos,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.proyectoslista,
              component: () => import("@/views/proyectos/proyectoLista.vue"),
              children: [],
            },
            {
              path: "kanban",
              name: RouterNames.proyectoskanban,
              component: () => import("@/views/proyectos/proyectoKanban.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.proyectosformulario,
              component: () =>
                import("@/views/proyectos/proyectoFormulario.vue"),
              children: [],
            },
          ],
        },
        {
          path: "usuarios",
          name: RouterNames.usuarios,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.usuarioslista,
              component: () => import("@/views/usuarios/UsuariosLista.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.usuariosformulario,
              component: () =>
                import("@/views/usuarios/UsuariosFormulario.vue"),
              children: [],
            },
          ],
        },
        {
          path: "departamentos",
          name: RouterNames.departamentos,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.departamentoslista,
              component: () =>
                import("@/views/departamentos/DepartamentosLista.vue"),
              children: [],
            },
          ],
        },
        {
          path: "grupos",
          name: RouterNames.grupos,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.gruposlista,
              component: () => import("@/views/grupos/GruposLista.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.gruposformulario,
              component: () => import("@/views/grupos/GruposFormulario.vue"),
              children: [],
            },
          ],
        },
        {
          path: "rol",
          name: RouterNames.rol,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.rollista,
              component: () => import("@/views/roles/RolesLista.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.rolformulario,
              component: () => import("@/views/roles/RolesFormulario.vue"),
              children: [],
            },
          ],
        },
        {
          path: "notificaciones",
          name: RouterNames.notificaciones,
          component: () =>
            import("@/views/notificaciones/NotificacionesForm.vue"),
        },
        {
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
